import styled from 'styled-components';

export const LoadWrapper = styled.div``;
export const OvalContainer = styled.div`
  margin-top: 20px;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  gap: 10px;
  width: 100%;
  height: 40px;
`;
export const Separator = styled.div`
  position: absolute;
  top: 77px;
  z-index: 1;
  left: 10px;
  background-color: #b7b7b7b7;
  width: 95%;
  height: 2px;
  margin-left: auto;
  margin-right: auto;
  opacity: 80%;
`;
export const ButtonStyle = styled.button`
  z-index: 4;
  border: none;
  display: flex;
  box-sizing: inherit;
  justify-content: center;
  gap: 10px;
  align-items: center;
  padding: 2px 5px;
  color: ${({ selected }) => (selected ? '#febf00' : 'white')};
  border-bottom: ${({ selected }) => (selected ? '4px solid #febf00' : 'none')};
  width: 47%;
  height: 100%;
  background-color: transparent;
`;
export const MapFilter = styled.input`
  all: unset;
  /* border-radius: 3px; */
  box-sizing: border-box;
  /* margin-top: 15px; */
  background-color: white;
  width: 100%;
  height: 28px;
  padding: 2px 10px;
  font-size: 16px;

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
    transition-delay: 9999s;
  }
`;
export const MapWrapper = styled.div`
  max-height: calc(100vh - 500px);
  min-height: 85px;
  margin-top: 10px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #333333;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }
`;
export const MapTitle = styled.p`
  margin: 3px 0;
  flex: 1;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  color: ${({ hovered }) => (hovered ? '#febf00' : 'white')};
`;
export const Text = styled.p`
  color: white;
  margin: 0;
  margin-top: 10px;
  font-size: 18px;
`;
export const UserMapWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DeleteMapButton = styled.button`
  border: none;
  background: transparent;
`;
